import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, NgZone, inject } from '@angular/core';
import Tracker from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
import { environment } from '../environments/environment';
import { NGXLogger } from 'ngx-logger';

type ReqRespType = {
  request: HttpRequest<any>,
  response: HttpResponse<any>
}


@Injectable({
  providedIn: 'root',
})
export class OpenReplayService {
  private zone = inject(NgZone);
  private logger = inject(NGXLogger);

  public tracker?: Tracker | null;

  private isEnable = false;

  constructor() {
    this.logger.log('OpenReplayService:constructor');
    const projectKey = environment.OPTIMISATION_OPEN_REPLAY;
    if (!projectKey) {
      this.logger.warn('OpenReplay project key is not set');
      return;
    }
    this.isEnable = true;
    this.initialise();
  }

  private initialise() {
    this.zone.runOutsideAngular(() => {
      if (!environment.OPTIMISATION_OPEN_REPLAY) {
        this.logger.warn('OpenReplay project key is not set');
        return;
      }
      this.tracker = new Tracker({
        projectKey: environment.OPTIMISATION_OPEN_REPLAY,
        // ingestPoint: 'https://someurl/',
        __DISABLE_SECURE_MODE: true,
      });

      this.tracker.use(
        trackerAssist({
          confirmText: `You have an incoming call from Sencha Tea Support. Would you like to accept?`,
        })
      );
    });
  }

  public async start() {
    if (!this.isEnable) {
      this.logger.log('OpenReplay is not enabled, ignoring start()');
      return;
    }
    this.logger.log('OpenReplayService:start');
    this.zone.runOutsideAngular(() => {
      if (this.tracker) {
        return this.tracker.start();
      } else {
        return {
          sessionID: null,
          sessionToken: null,
          userUUID: null,
        };
      }
    });
  }

  public setUserData(user: { id: string }): void {
    if (!this.isEnable) {
      this.logger.log('OpenReplay is not enabled, ignoring setUserData()');
      return;
    }
    this.logger.log('OpenReplayService:setUserData');
    this.zone.runOutsideAngular(() => {
      if (this.tracker && user.id) {
        this.tracker.setUserID(String(user.id));
      }
    });
  }

  sendEventToReplaySession(event: string, params: ReqRespType): void {
    if (!this.isEnable) {
      this.logger.log('OpenReplay is not enabled, ignoring sendEventToReplaySession()');
      return;
    }
    const {request, response} = params

    this.logger.log(`Sending event ${event} to OpenReplay`);

    this.tracker?.event(event + "[request]", {
      method: request.method,
      url: request.url,
      params: request.params
    })
    this.tracker?.event(event + "[response]", {
      body: response.body,
      status: response.status,
      headers: response.headers
    })
  }
}
